import { IPosition } from 'src/generated-types'

export const buildListOrder = (unconfiguredPositions: IPosition[], sortedCards: { positions: IPosition[] }[]) => {
  return [
    ...unconfiguredPositions.map(position => position.id),
    ...sortedCards.flatMap(card => card.positions.map(position => position.id)),
  ]
}

export const getRangeBetween = (listOrder: number[], fromId: number | null, toId: number) => {
  if (fromId == null) return null
  const fromIndex = listOrder.indexOf(fromId)
  const toIndex = listOrder.indexOf(toId)
  if (fromIndex < 0 || toIndex < 0) return null
  return listOrder.slice(Math.min(fromIndex, toIndex), Math.max(fromIndex, toIndex) + 1)
}
